import { render, staticRenderFns } from "./TaskChildren.vue?vue&type=template&id=ffff9c64&scoped=true"
import script from "./TaskChildren.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskChildren.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffff9c64",
  null
  
)

export default component.exports